module.exports = __webpack_public_path__ + "static/media/scu_map.155bfe4d.svg";